<template>
  <v-hover #default="{ hover }">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :color="cancel ? '#fff' : color"
      :outlined="cancel"
      :ripple="false"
      depressed
      :class="{ hover: hover, 'font--text': cancel, cancel: cancel }"
    >
      <v-icon v-if="textIcon" :class="{ 'pr-1': !!text }" size="18" :color="iconColor"> {{ textIcon }}</v-icon>
      <span> {{ $i18n.t(text) }}</span>
    </v-btn>
  </v-hover>
</template>

<script>
export default {
  name: 'BaseButton',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: '',
    },
    textIcon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    cancel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconColor() {
      return this.$_isHexColorLight(this.$_colors[this.color] || this.color) ? '#202124' : 'white';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  &.v-btn {
    letter-spacing: normal;
    text-transform: initial;
    &.hover {
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
    &.cancel {
      background-color: #fff;
      border-color: rgba(0, 0, 0, 0.2);
      &.hover {
        box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 8px 0 rgba(0, 0, 0, 0.12);
      }
    }
  }
}
</style>
